export default __webpack_public_path__ + "static/media/White-commentIcon.be3ac171.svg";